import React from "react";

const Footer = () => {
  return (
    <footer className="container-fluid bg-dark text-white py-4">
      <div className="container text-center">
        <p>Copyright &copy; Om Sai Aqua 2026. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
